module.exports = __webpack_public_path__ + "static/media/promo.367fece5.png";